import React, { useState, useEffect } from 'react'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import {
  Loading,
  Tooltip,
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  BUTTON_VARIANT_DANGER,
  ToastContainer,
  Title,
  TITLE_VARIANT_M,
  SpacingVertical,
  SPACING_24,
  SPACING_8,
  GridCell,
  Grid,
  ModalConfirm,
  toastShow,
  TOAST_VARIANT_WARNING,
  TOAST_VARIANT_SUCCESS,
  Flex
} from 'mailup-web-components'
import Header from './components/Header'
import {
  abTestManageIsValidState,
  modalResumeTestState,
  modalStopSendingWinnerState,
  modalStopTestState,
  pageState
} from './recoil/state/page'
import PageContainer from 'Components/PageContainer'
import ErrorFeedback from 'Components/ErrorFeedback'
import { useParams, useHistory } from 'react-router-dom'
import {
  checkResumeTestCallback,
  cleanABTestCallback,
  getABTestResultCallback,
  initAbTestManageCallback,
  resetCallback,
  resumeTestCallback,
  saveAndRescheduleCallback,
  stopTestCallback
} from './recoil/callbacks/callbacks'
import { abTestState } from './recoil/state/abTest'
import AbTestInfoOnSheduling from './components/AbTestInfoOnSheduling'
import AbTestInfo from './components/AbTestInfo'
import AbTestMessages from './components/AbTestMessages'
import { useIntl } from 'react-intl'
import AbTestWinnerMessage from './components/AbTestWinnerMessage'
import AbTestWinnerStartDate from './components/AbTestWinnerStartDate'
import AbTestSchedulingAutomaticAfter from './components/AbTestSchedulingAutomaticAfter'
import { evalCondition, notifyParent, zones } from 'mailup-react-helpers'
import {
  ABTEST_STATUS_COMPLETED,
  ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED,
  ABTEST_STATUS_STOP_DURING_TEST,
  ABTEST_STATUS_STOP_DURING_WINNER
} from 'Api/beABTestApi'

import { ModalConfirmLeave } from './components/ModalConfirmLeave'
import BoxDate from './components/BoxDate'
import moment from 'moment-timezone'
import useBeforeUnload from 'Hooks/useRouteBeforeUnload'
import { contentScheduledState } from 'Components/ContentScheduled/recoil/state'

const AbTestManage = () => {
  const intl = useIntl()
  const { loading, error, severity, loaded } = useRecoilValue(pageState)
  const {
    Info,
    testNotStartMode,
    testStopped,
    winnerSendStopped,
    sendingWinner,
    testCompleted,
    testRunning,
    testEnded,
    disableStatBtn,
    idAggregateReport,
    showStopTestBtn,
    showStopSendWinnerBtn,
    existsFailedSending,
    startWinnerMessageDate
  } = useRecoilValue(abTestState)
  const { changeHistory, IsDirty } = useRecoilValue(abTestState)
  const { id } = useParams()
  const history = useHistory()
  const init = useRecoilCallback(initAbTestManageCallback, [])
  const getABTestResult = useRecoilCallback(getABTestResultCallback, [])
  const cleanup = useRecoilCallback(resetCallback, [])
  const saveAndReschedule = useRecoilCallback(saveAndRescheduleCallback, [])
  const abTestManageIsValid = useRecoilValue(abTestManageIsValidState)
  const [{ showModalResumeTest }, setmodalResumeTestState] = useRecoilState(
    modalResumeTestState
  )
  const [
    { showModalStopSendingWinner },
    setModalStopSendingWinnerState
  ] = useRecoilState(modalStopSendingWinnerState)
  const [{ showModalStopTest }, setModalStopTestState] = useRecoilState(
    modalStopTestState
  )
  const checkResumeTest = useRecoilCallback(checkResumeTestCallback, [])
  const resumeTest = useRecoilCallback(resumeTestCallback, [])
  const cleanABTest = useRecoilCallback(cleanABTestCallback, [])
  const stopTest = useRecoilCallback(stopTestCallback, [])
  const { isDirty: dateIsDirty } = useRecoilValue(contentScheduledState)
  // alert di uscita dalla pagina senza salvare
  useBeforeUnload(IsDirty || dateIsDirty)
  useEffect(() => {
    return () => {
      cleanup()
    }
  }, [])
  useEffect(() => {
    !loaded && init(id)
  }, [loaded])
  useEffect(() => {
    if (!testNotStartMode && loaded) {
      getABTestResult(id)
    }
  }, [loaded])
  useEffect(() => {
    changeHistory && history.push(changeHistory)
  }, [changeHistory])
  const detailedStatistics = () => {
    const url =
      'statistics_app_redirector.aspx?r=/stats/insight/aggregate/view/' +
      idAggregateReport.AggregateReportId
    notifyParent('redirectMainFrame', [url])
  }
  const onClickStopTest = () => {
    setModalStopTestState(prev => ({ showModalStopTest: true }))
  }
  const handleStopTest = () => {
    setModalStopSendingWinnerState(prev => ({
      showModalStopSendingWinner: false
    }))
    setModalStopTestState(prev => ({
      showModalStopTest: false
    }))
    stopTest(id).then(resp => {
      if (resp) {
        init(id)
        toastShow(
          intl.formatMessage({ id: 'Load.AbTest.AbTestStopSucces' }),
          TOAST_VARIANT_SUCCESS,
          'AbTestStopSucces'
        )
      } else {
        toastShow(
          intl.formatMessage({ id: 'Load.AbTest.StopTestNotPossible' }),
          TOAST_VARIANT_WARNING,
          'StopTestNotPossible'
        )
      }
    })
  }
  const handleCloseStopTest = () => {
    setModalStopTestState(prev => ({
      showModalStopTest: false
    }))
  }
  const onClickStopSendWinner = () => {
    setModalStopSendingWinnerState(prev => ({
      showModalStopSendingWinner: true
    }))
  }
  const handleStopSendingWinner = () => {
    handleStopTest()
  }
  const handleCloseStopSendingWinner = () => {
    setModalStopSendingWinnerState(prev => ({
      showModalStopSendingWinner: false
    }))
  }
  const onClickCleanABTest = () => {
    cleanABTest(id)
  }
  const onClickTestResume = () => {
    checkResumeTest(id)
  }
  const handleResumeTest = () => {
    setmodalResumeTestState(prev => ({ showModalResumeTest: false }))
    resumeTest(id).then(resp => {
      if (resp) {
        init(id).then(() => {
          switch (Info.Stato) {
            case ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED:
              if (Info.TipoTest === 'A') {
                const stringToReplace = intl.formatMessage({
                  id: 'Load.AbTest.ResumeAutoSuccess'
                })
                const date =
                  Info.WinnerDateCTZScheduled?.replace('T', ' ').replace(
                    'Z',
                    ' '
                  ) + Info.WinnerDateCTZScheduled?.split('.')[0]
                const alert = stringToReplace.replace('[DATE]', date)
                toastShow(alert, TOAST_VARIANT_SUCCESS, 'ResumeAutoSuccess')
              }
              if (Info.TipoTest === 'M') {
                toastShow(
                  intl.formatMessage({ id: 'Load.AbTest.ResumeManualSuccess' }),
                  TOAST_VARIANT_SUCCESS,
                  'ResumeManualSuccess'
                )
              }
              break
            default:
              toastShow(
                intl.formatMessage({ id: 'Load.AbTest.ResumeRunningSuccess' }),
                TOAST_VARIANT_SUCCESS,
                'ResumeRunningSuccess'
              )
              break
          }
        })
      } else {
        toastShow(
          intl.formatMessage({ id: 'Load.AbTest.ResumeTestNotPossible' }),
          TOAST_VARIANT_WARNING,
          'ResumeTestNotPossible'
        )
      }
    })
  }
  const handleCloseResumeTest = () => {
    setmodalResumeTestState(prev => ({ showModalResumeTest: false }))
  }

  const [scheduledDate, setScheduledDate] = useState(undefined)
  useEffect(() => {
    if (startWinnerMessageDate) {
      setScheduledDate(
        moment
          .tz(
            startWinnerMessageDate.replace('Z', ''),
            zones[Info.TimeZoneScheduled]
          )
          .utc()
      )
    }
  }, [startWinnerMessageDate])
  const getScheduledDate = () => {
    if (Info && Info.TestDateCTZScheduled) {
      return moment
        .tz(
          Info.TestDateCTZScheduled.replace('Z', ''),
          zones[Info.TimeZoneScheduled]
        )
        .utc()
    }
  }

  const [winnerMessageDate, setWinnerMessageDate] = useState(undefined)

  useEffect(() => {
    if (startWinnerMessageDate) {
      setWinnerMessageDate(
        moment
          .tz(
            startWinnerMessageDate.replace('Z', ''),
            zones[Info.TimeZoneScheduled]
          )
          .utc()
      )
    }
  }, [startWinnerMessageDate])
  const getWinnerMessageDate = () => {
    if (startWinnerMessageDate) {
      er
      return moment
        .tz(
          startWinnerMessageDate.replace('Z', ''),
          zones[Info.TimeZoneScheduled]
        )
        .utc()
    }
  }
  return (
    <>
      <ModalConfirmLeave />
      {/* modal resume test  testStopped */}
      <ModalConfirm
        show={showModalResumeTest}
        title={
          testStopped
            ? intl.formatMessage({
                id: 'Load.AbTest.ModalResumeTestTitleDescr'
              })
            : intl.formatMessage({
                id: 'Load.ABTestManage.WinnerMessageResumeModalTitle'
              })
        }
        message={
          testStopped
            ? intl.formatMessage({
                id: 'Load.AbTest.ModalResumeTestConfirmDescr'
              })
            : intl.formatMessage({
                id: 'Load.ABTestManage.WinnerMessageResumeModalBody'
              })
        }
        stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Yes' })}
        stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
        onClickConfirm={handleResumeTest}
        onClickCancel={handleCloseResumeTest}
      />
      {/* /* modal stop sending winner */}
      <ModalConfirm
        show={showModalStopSendingWinner}
        title={intl.formatMessage({
          id: 'Load.AbTest.ModalStopSendWinnerConfirmTitle'
        })}
        message={intl.formatMessage({
          id: 'Load.AbTest.ModalStopSendWinnerConfirmDescr'
        })}
        stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Yes' })}
        stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
        onClickConfirm={handleStopSendingWinner}
        onClickCancel={handleCloseStopSendingWinner}
      />
      {/* modal stop test */}
      <ModalConfirm
        show={showModalStopTest}
        title={intl.formatMessage({
          id: 'Load.AbTest.ModalStopTestConfirmTitle'
        })}
        message={intl.formatMessage({
          id: 'Load.AbTest.ModalStopTestConfirmDescr'
        })}
        stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Yes' })}
        stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
        onClickConfirm={handleStopTest}
        onClickCancel={handleCloseStopTest}
      />
      <Header />
      <Loading open={loading} />
      <ToastContainer />
      <Tooltip />
      <PageContainer>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={() => init(id)}
        />
        {!error && !loading && loaded && (
          <>
            {testNotStartMode && (
              <>
                <AbTestInfoOnSheduling />
                <SpacingVertical variant={SPACING_24} />
              </>
            )}
            {!testNotStartMode && <AbTestInfo />}

            <Title variant={TITLE_VARIANT_M}>
              {intl.formatMessage({ id: 'Load.ABTestWizard.TitleTest' })}
            </Title>
            <SpacingVertical variant={SPACING_8} />
            <Grid cols={testNotStartMode ? 2 : 1}>
              <GridCell>
                <AbTestMessages />
              </GridCell>
              {testNotStartMode && (
                <GridCell>
                  {scheduledDate && (
                    <BoxDate
                      scheduleDate={scheduledDate}
                      scheduleTimeZoneCode={Info.TimeZoneScheduled}
                    />
                  )}
                  {/* <BoxDate
                    scheduleDate={() => getScheduledDate()}
                    scheduleTimeZoneCode={Info.TimeZoneScheduled}
                  /> */}
                </GridCell>
              )}
            </Grid>
            {Info.TipoTest === 'X' && <SpacingVertical variant={SPACING_24} />}
            {Info && (Info.TipoTest === 'A' || Info.TipoTest === 'M') && (
              <>
                <SpacingVertical variant={SPACING_24} />
                <Title variant={TITLE_VARIANT_M}>
                  {intl.formatMessage({ id: 'Load.ABTestWizard.TitleWinner' })}
                </Title>
                <SpacingVertical variant={SPACING_8} />
                <Grid
                  cols={
                    testStopped ||
                    winnerSendStopped ||
                    (testNotStartMode && Info && Info.TipoTest === 'M')
                      ? 1
                      : 2
                  }
                >
                  <GridCell>
                    <AbTestWinnerMessage />
                  </GridCell>
                  {!testNotStartMode && !testStopped && !winnerSendStopped && (
                    <>
                      <GridCell>
                        {(testRunning || testEnded) && winnerMessageDate && (
                          <BoxDate
                            scheduleDate={winnerMessageDate}
                            scheduleTimeZoneCode={
                              Info && Info.TimeZoneScheduled
                            }
                          />
                        )}
                        {(sendingWinner || testCompleted) && (
                          <AbTestWinnerStartDate />
                        )}
                      </GridCell>
                    </>
                  )}
                  {testNotStartMode && Info && Info.TipoTest === 'A' && (
                    <GridCell>
                      <AbTestSchedulingAutomaticAfter />
                    </GridCell>
                  )}
                </Grid>
                <SpacingVertical variant={SPACING_24} />
              </>
            )}

            <Flex margin='0 0 40px 0' flexDirection='row-reverse'>
              {testNotStartMode && (
                <Button
                  kind={BUTTON_VARIANT_PRIMARY}
                  disabled={!abTestManageIsValid}
                  data-mu-test='abTestManage-Save'
                  onClick={saveAndReschedule}
                >
                  {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
                </Button>
              )}
              {!testNotStartMode && (
                <>
                  {!testRunning && !disableStatBtn && evalCondition('uo:STAT') && (
                    <Button
                      kind={
                        Info &&
                        (Info.TipoTest === 'X' ||
                          Info.Stato === ABTEST_STATUS_COMPLETED ||
                          Info.Stato === ABTEST_STATUS_STOP_DURING_WINNER ||
                          Info.Stato === ABTEST_STATUS_STOP_DURING_TEST)
                          ? BUTTON_VARIANT_PRIMARY
                          : BUTTON_VARIANT_SECONDARY
                      }
                      disabled={!abTestManageIsValid}
                      data-mu-test='abTestManage-GoToStat'
                      onClick={detailedStatistics}
                    >
                      {intl.formatMessage({
                        id: 'Load.AbTest.ShowDetailedStatistics'
                      })}
                    </Button>
                  )}
                  {showStopTestBtn && !testStopped && (
                    <Button
                      kind={BUTTON_VARIANT_DANGER}
                      data-mu-test='abTestManage-StopTest'
                      onClick={onClickStopTest}
                    >
                      {intl.formatMessage({ id: 'Load.AbTest.StopTest' })}
                    </Button>
                  )}
                  {showStopSendWinnerBtn && !winnerSendStopped && (
                    <Button
                      kind={BUTTON_VARIANT_DANGER}
                      data-mu-test='abTestManage-StopSendWinner'
                      onClick={onClickStopSendWinner}
                    >
                      {intl.formatMessage({ id: 'Load.AbTest.StopSendWinner' })}
                    </Button>
                  )}
                  {existsFailedSending && testCompleted && (
                    <Button
                      kind={BUTTON_VARIANT_DANGER}
                      data-mu-test='abTestManage-Clean'
                      onClick={onClickCleanABTest}
                    >
                      {intl.formatMessage({
                        id: 'Load.AbTest.CleanABTestMessageFail'
                      })}
                    </Button>
                  )}
                  {(testStopped || winnerSendStopped) && (
                    <Button
                      kind={BUTTON_VARIANT_SECONDARY}
                      data-mu-test='abTestManage-Resume'
                      onClick={onClickTestResume}
                    >
                      {intl.formatMessage({ id: 'Load.AbTest.Resume' })}
                    </Button>
                  )}
                </>
              )}
            </Flex>
          </>
        )}
      </PageContainer>
    </>
  )
}
export default AbTestManage
